import React, { useEffect, useState } from "react";
import InviteModal from "./InviteModal/invitemodal";
import BranchService from "src/Services/API/branch.service";
import { toast } from "react-toastify";
import UserService from "src/Services/API/user.service";
import InviteService from "src/Services/API/invite.service";
import RoleService from "src/Services/API/role.service";
import { formatDate } from "src/Common/common";
import AcceptStatus from "./Status/acceptstatus";
import PendingStatus from "./Status/pendingstatus";
import ConfirmDialog from "src/Common/confirmdialog";
import { useSelector } from "react-redux";
import { can } from "src/Common/function";
import { useSearchParams } from "react-router-dom";

const Invite = ({ inviteModalShown, setInviteModalShown }) => {
  // const branch = useSelector((state) => state.Branch.branch);
  let currentUser = UserService.getCurrentUser();
  const [branchArray, setBranchArray] = useState([]);
  const [roleArray, setRoleArray] = useState([]);
  const [inviteArray, setInviteArray] = useState([]);

  const [cancelIndex, setCancelIndex] = useState(null);

  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  useEffect(() => {
    BranchService.getAll()
      .then((response) => {
        console.log("Role list: ", response);
        if (response.status == 200) {
          setBranchArray(response.data.filter((b) => currentUser.branches.some((b2) => b2.id == b.id)));
        }
      })
      .catch((error) => {
        if (error.response) {
          toast(error.response.data.message);
        } else {
          toast("An error occured");
        }
      });

    RoleService.getAll()
      .then((response) => {
        console.log("Role list: ", response);
        if (response.status == 200) {
          setRoleArray(response.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          toast(error.response.data.message);
        } else {
          toast("An error occured");
        }
      });

    getAllInvites();
  }, [branch]);

  const getAllInvites = () => {
    InviteService.getAll(branch)
      .then((response) => {
        console.log("Invite list: ", response);
        if (response.status == 200) {
          setInviteArray(response.data);
        }
      })
      .catch((error) => {
        toast("An error occured");
      });
  };

  const sendInvite = (email, role, branch) => {
    console.log("🚀 ~ sendInvite ~ branch:", branch);
    InviteService.create({
      invitedBy: currentUser,
      email: email.trim().toLowerCase(),
      role,
      branch,
      company: currentUser.company,
    })
      .then((response) => {
        getAllInvites();
        toast("User invited successfully");
      })
      .catch((error) => {
        if (error.response) {
          toast(error.response.data.message);
        } else {
          toast("An error occured");
        }
      });

    setInviteModalShown(false);
  };

  const confirmCancelInvite = () => {
    if (cancelIndex === null) return;
    InviteService.deleteInvite(inviteArray[cancelIndex].id)
      .then((response) => {
        getAllInvites();
        toast("Invite cancelled successfully");
      })
      .catch((error) => {
        toast("An error occured");
      })
      .finally(() => {
        setCancelIndex(null);
      });
  };

  return (
    <div className="h-full flex flex-col min-h-0">
      <ConfirmDialog
        title="CANCEL INVITE"
        description="Are you sure you want to cancel this invite?"
        shown={cancelIndex !== null}
        onConfirmClicked={confirmCancelInvite}
        onCancelClicked={() => setCancelIndex(null)}
      />
      <InviteModal
        sendInvite={sendInvite}
        shown={inviteModalShown}
        roleArray={roleArray}
        branchArray={branchArray}
        onCancelClicked={() => setInviteModalShown(false)}
      />
      <div
        className="w-full mt-3 mb-3 flex-1 min-h-0 flex flex-col overflow-hidden"
        style={{
          borderRadius: "12px",
          border: "1px solid #E5E8F3",
          background: "#FFF",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.00), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <table className="w-full table-fixed">
          <thead className="sticky top-0 z-10">
            <tr style={{ borderBottom: "1px solid #E5E8F3", background: "#F8F9FE" }}>
              <th className="w-[30%]">
                <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                  <span>Email</span>
                </div>
              </th>
              <th className="w-[20%]">
                <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                  Role
                </div>
              </th>
              <th className="w-[25%]">
                <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                  Status
                </div>
              </th>
              <th className="w-[25%]">
                <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                  Invited At
                </div>
              </th>
              <th className="w-[100px]">
                <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                  Action
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {inviteArray.map((invite, i) => (
              <tr key={i} className="border-b border-borderColor hover:bg-[#FAFAFB]">
                <td>
                  <div className="font-OpenSansRegular px-4 py-3 text-[14px] font-[400] leading-[20px] text-[#5F6477] truncate">
                    {invite.email}
                  </div>
                </td>
                <td>
                  <div className="font-OpenSansRegular px-4 py-3 text-[14px] font-[400] leading-[20px] text-[#5F6477]">
                    {invite.role.name}
                  </div>
                </td>
                <td>
                  <div className="font-OpenSansRegular px-4 py-3 text-[14px] font-[400] leading-[20px] text-[#5F6477]">
                    {invite.accepted ? <AcceptStatus /> : <PendingStatus />}
                  </div>
                </td>
                <td>
                  <div className="font-OpenSansRegular px-4 py-3 text-[14px] font-[400] leading-[20px] text-[#5F6477]">
                    {formatDate(invite.createdAt)}
                  </div>
                </td>
                <td>
                  <div className="px-4 py-3">
                    {can("user:cancelInvite") && (
                      <div
                        onClick={() => setCancelIndex(i)}
                        className="w-[70px] h-[25px] text-[12px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                      >
                        CANCEL
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default Invite;
